import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { topRatedHelpers } from 'site-modules/shared/utils/top-rated/top-rated-helpers';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { CmsEntities } from 'client/data/models/cms';

export function WinnerTilesNavArticle({ winnerVehicles, year = null, winnerTitle = null, title = null }) {
  return (
    <article className="winners mb-3_5 pb-md-1">
      <header
        className={`heading-3 mt-3 mb-1_75 mb-md-2 text-center ${topRatedHelpers.swapTextColor('text-white', year)}`}
      >
        {winnerTitle}
      </header>
      <nav className="mx-auto" aria-label="other top rated winners">
        {winnerVehicles
          .filter(winnerVehicle => winnerVehicle && winnerVehicle.metadata('categoryTitle').value() !== title)
          .map(winnerVehicle => {
            const categoryTitle = winnerVehicle.metadata('categoryTitle').value();
            const vehicleName = winnerVehicle.metadata('vehicleTitle').value();
            const disableClickThrough = winnerVehicle.metadata('disableClickThrough').value() === 'true';
            const vehicleLink = winnerVehicle.links()[0];
            const vehicleHref = vehicleLink.href;
            const vehicleCaption = vehicleLink.captionTranscript;
            const vehicleTileURL = winnerVehicle.metadata('tileURL').value();
            return (
              <figure
                key={`photo-${categoryTitle}`}
                className={classnames('pos-r mb-md-2 mb-1', {
                  'enable-hover-state': !disableClickThrough,
                })}
              >
                <img src={getFullImageUrl(vehicleHref, 700)} alt={vehicleCaption} width="100%" loading="lazy" />

                <figcaption>
                  {disableClickThrough ? (
                    <span className="d-block vehicle-name mt-0_75 mb-0_25 text-primary size-14">{categoryTitle}</span>
                  ) : (
                    <a
                      href={vehicleTileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block vehicle-name mt-0_75 mb-0_25 text-primary size-14"
                    >
                      {categoryTitle}
                    </a>
                  )}
                  <span
                    className={classnames(
                      'd-block vehicle-name fw-bold',
                      topRatedHelpers.swapTextColor('text-white', year)
                    )}
                  >
                    {vehicleName}
                  </span>
                </figcaption>
              </figure>
            );
          })}
      </nav>
    </article>
  );
}

WinnerTilesNavArticle.propTypes = {
  winnerVehicles: PropTypes.arrayOf(CmsEntities.Content).isRequired,
  year: PropTypes.string,
  winnerTitle: PropTypes.string,
  title: PropTypes.string,
};
